import { memo } from "react";
import { MotifAvatar } from "@ey-xd/motif-react";

import "./Avatar.scss";

const Avatar = ({
    src,
    userName,
    className,
    description,
    size,
    status = undefined,
    variant = "image"
}) => {
    const normalizedUserName = typeof userName === 'string' ? userName.trim() : (userName ? String(userName) : "");
    
    return (
        <MotifAvatar
            className={`avatar ${className || ""}`}
            userName={normalizedUserName}
            src={src}
            description={description}
            size={size}
            status={status}
            variant={variant}
            data-testid="avatar-container"
        />
    );
};

export default memo(Avatar);
